export default {"src":"/_next/static/media/hotline24_64.0abba290.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};